import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getCargos, getRepresentacion, getTipoDocumento, getTipoMatricula, } from "../../../../redux/actions/empleador";
import FormikActions from "../../formik/FormikActions";
import FormikAutocomplete from "../../formik/FormikAutocomplete";
import FormikCheckbox from "../../formik/FormikCheckbox";
import FormikTextField from "../../formik/FormikTextField";
import CircularLoading from "../../loading/CircularLoading";
import { esSeguridadOMedicina, validateNewResponsable } from "../validation";

const initialValues = {
  cargoEmpresa: null,
  nombreCargoEmpresa: "",
  responsableDatos: false,
  apellido: "",
  nombres: "",
  cuit: "",
  tipoDocumento: "",
  numeroDocumento: null,
  representacion: null,
  propio: false,
  telefono: "",
  email: "",
  tipoMatricula: null,
  nroMatricula: "",
  horasAsignadas: null,
  titulo: "",
  matriculaOtorgadaPor: "",
};
const labelObligatorio = (string, esObligatorio) => {
  return esObligatorio ? string + " *" : string;
}

const NewResponsableDialog = ({
  open,
  handleClose,
  handleSubmit,
  loading = false,
  cu,
  isResponsableDatos,
}) => {
  const dispatch = useDispatch();

  const cargos = useSelector((state) => state.empleador.cargos);
  const tipoDocumento = useSelector((state) => state.empleador.tipoDocumento);
  const representacion = useSelector((state) => state.empleador.representacion);
  const tipoMatricula = useSelector((state) => state.empleador.tipoMatricula);

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Nuevo responsable</DialogTitle>
      <Formik
        initialValues={{
          ...initialValues,
          ...(cargos?.data.length === 1 && {
            cargoEmpresa: cargos.data[0].id,
            nombreCargoEmpresa: cargos.data[0].nombre,
          }),
          ...(isResponsableDatos && {
            responsableDatos: true,
          })
        }}
        enableReinitialize
        onSubmit={(values) => {

          handleSubmit({ ...values, numeroDocumento: values.numeroDocumento ? parseInt(values.numeroDocumento) : null });
        }}
        validationSchema={validateNewResponsable}
      >
        {({ setFieldValue, values, errors }) => (
          <Form>
            <DialogContent>
              {loading ? (
                <CircularLoading />
              ) : (
                <Grid container spacing={2}>
                  <Grid item container xs={12} spacing={2}>
                    <Grid item xs={7}>
                      <div>
                        <FormikAutocomplete
                          name="cargoEmpresa"
                          label="Cargo *"
                          options={cargos.data}
                          renderOption={(option) => option.nombre}
                          filterOptions={(option) => option.nombre}
                          disabled={cargos.data.length === 1}
                          getOptions={() => dispatch(getCargos(cu)).then((res) => {
                            let cargos = res?.value?.data;
                            if (cargos?.length === 1) {

                              setFieldValue('cargoEmpresa', cargos[0].id);
                              setFieldValue('nombreCargoEmpresa', cargos[0].nombre);
                            }
                          })}
                          callBack={(inputValue) => {
                            if (inputValue) {

                              setFieldValue('nombreCargoEmpresa', inputValue.nombre)
                            }
                          }}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={5}>
                      <div>
                        <FormikCheckbox
                          name="responsableDatos"
                          label="Responsable datos"
                          disabled={isResponsableDatos}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  {/* segunda fila */}
                  <Grid item container xs={12} spacing={2}>
                    <Grid item xs={6}>
                      <div>
                        <FormikTextField
                          name="apellido"
                          label="Apellido *"
                          type="text"
                          fullWidth
                        />
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <div>
                        <FormikTextField
                          name="nombres"
                          label="Nombre *"
                          type="text"
                          fullWidth
                        />
                      </div>
                    </Grid>
                  </Grid>
                  {/* tercera fila */}
                  <Grid item container xs={12} spacing={2}>
                    <Grid item xs={4}>
                      <div>
                        <FormikTextField name="cuit" label="CUIT/CUIL *" fullWidth />
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div>
                        <FormikAutocomplete
                          name="tipoDocumento"
                          label="Tipo documento"
                          options={tipoDocumento.data}
                          renderOption={(option) => option.nombre}
                          filterOptions={(option) => option.nombre}
                          getOptions={() => dispatch(getTipoDocumento())}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div>
                        <FormikTextField
                          name="numeroDocumento"
                          label="N.º documento"
                          fullWidth
                        />
                      </div>
                    </Grid>
                  </Grid>
                  {/* cuarta fila */}
                  <Grid item container xs={12} spacing={2}>
                    <Grid item xs={8}>
                      <div>
                        <FormikAutocomplete
                          name="representacion"
                          label="Representación *"
                          options={representacion.data}
                          renderOption={(option) => option.nombre}
                          filterOptions={(option) => option.nombre}
                          getOptions={() => dispatch(getRepresentacion())}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div>
                        <FormikCheckbox name="propio" label="Propio" />
                      </div>
                    </Grid>
                  </Grid>
                  {/* quinta fila */}
                  <Grid item container xs={12} spacing={2}>
                    <Grid item xs={6}>
                      <div>
                        <FormikTextField
                          name="telefono"
                          label="Teléfono *"
                          type="text"
                          fullWidth
                        />
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <div>
                        <FormikTextField
                          name="email"
                          label="Mail *"
                          type="text"
                          fullWidth
                        />
                      </div>
                    </Grid>
                  </Grid>
                  {/* sexta fila */}
                  <Grid item container xs={12} spacing={2}>
                    <Grid item xs={4}>
                      <div>
                        <FormikAutocomplete
                          name="tipoMatricula"
                          label={labelObligatorio("Tipo matrícula", esSeguridadOMedicina(values.nombreCargoEmpresa))}
                          options={tipoMatricula.data}
                          renderOption={(option) => option.nombre}
                          filterOptions={(option) => option.nombre}
                          getOptions={() => dispatch(getTipoMatricula())}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div>
                        <FormikTextField
                          name="nroMatricula"
                          label={labelObligatorio("N.º matrícula", esSeguridadOMedicina(values.nombreCargoEmpresa))}
                          fullWidth
                        />
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div>
                        <FormikTextField
                          name="horasAsignadas"
                          label="Horas asignadas"
                          fullWidth
                        />
                      </div>
                    </Grid>
                  </Grid>
                  {/* septima fila */}
                  <Grid item container xs={12} spacing={2}>
                    <Grid item xs={6}>
                      <div>
                        <FormikTextField
                          name="titulo"
                          label="Título"
                          type="text"
                          fullWidth
                        />
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <div>
                        <FormikTextField
                          name="matriculaOtorgadaPor"
                          label={labelObligatorio("Título otorgado por", esSeguridadOMedicina(values.nombreCargoEmpresa))}
                          type="text"
                          fullWidth
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </DialogContent>
            <DialogActions>
              <FormikActions
                handleCancel={handleClose}
                loading={loading}
              />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default NewResponsableDialog;
